import styled from 'styled-components';

export const Container = styled.div`
  overflow: hidden;
  padding: 30px;
  position: absolute;
  right: 0;
  top: 0;
`;
